/**
 * @file api/settings.js
 * @description API functions for the /api/settings resource (admin only).
 */

import apiClient from './client';

/** @returns {Promise<Array<{key: string, value: *}>>} */
export const listSettings = async () => {
  const res = await apiClient.get('/api/settings');
  return res.data;
};

/**
 * @param {string} key
 * @param {*} value
 * @returns {Promise<{key: string, value: *}>}
 */
export const updateSetting = async (key, value) => {
  const res = await apiClient.put(`/api/settings/${key}`, { value });
  return res.data;
};
